module.exports = __webpack_public_path__ + "img/passport-front.e55cc279.jpg";